import React, { ReactElement } from 'react';
import { CheckboxFormField } from '../Fieldset/CheckboxFormField';
import { SummaryConsentFormModel, SummaryConsentFormModelFields } from './summaryConsentForm.model';

const vwfsGroup: (keyof SummaryConsentFormModel)[] = ['emailVWFS', 'mobilePhoneVWFS', 'landlineVWFS', 'postVWFS'];
const bpGroup: (keyof SummaryConsentFormModel)[] = ['emailBP', 'mobilePhoneBP', 'landlineBP', 'postBP'];

const unCheckOtherFields =
  (group: (keyof SummaryConsentFormModel)[], currentField?: keyof SummaryConsentFormModel) =>
  (checked: boolean, setFieldValue: (field: string, value: any) => void) => {
    // Parent behavior:
    // If no currentField is provided and checkbox becomes unchecked reset the whole group.
    if (!currentField && !checked) {
      group.forEach((field) => setFieldValue(field, false));
      return;
    }

    // Child behavior:
    // If a field is checked, uncheck all other fields in the group.
    if (currentField && checked) {
      group.forEach((field) => {
        if (field !== currentField) {
          setFieldValue(field, false);
        }
      });
    }
  };

export const createFormInputs = ((disableAllFormControls: boolean) => {
  return {
    marketingVWFS: () => (
      <CheckboxFormField
        fieldName="marketingVWFS"
        labelTranslationKey="consents:marketingVWFS"
        isDisabled={disableAllFormControls}
        onCheckedChange={unCheckOtherFields(vwfsGroup)}
      />
    ),
    emailVWFS: () => (
      <CheckboxFormField
        fieldName="emailVWFS"
        labelTranslationKey="consents:email"
        isDisabled={disableAllFormControls}
        onCheckedChange={unCheckOtherFields(vwfsGroup, 'emailVWFS')}
      />
    ),
    mobilePhoneVWFS: () => (
      <CheckboxFormField
        fieldName="mobilePhoneVWFS"
        labelTranslationKey="consents:mobilePhone"
        isDisabled={disableAllFormControls}
        onCheckedChange={unCheckOtherFields(vwfsGroup, 'mobilePhoneVWFS')}
      />
    ),
    landlineVWFS: () => (
      <CheckboxFormField
        fieldName="landlineVWFS"
        labelTranslationKey="consents:landline"
        isDisabled={disableAllFormControls}
        onCheckedChange={unCheckOtherFields(vwfsGroup, 'landlineVWFS')}
      />
    ),
    postVWFS: () => (
      <CheckboxFormField
        fieldName="postVWFS"
        labelTranslationKey="consents:post"
        isDisabled={disableAllFormControls}
        onCheckedChange={unCheckOtherFields(vwfsGroup, 'postVWFS')}
      />
    ),
    marketingBP: () => (
      <CheckboxFormField
        fieldName="marketingBP"
        labelTranslationKey="consents:marketingBP"
        isDisabled={disableAllFormControls}
        onCheckedChange={unCheckOtherFields(bpGroup)}
      />
    ),
    emailBP: () => (
      <CheckboxFormField
        fieldName="emailBP"
        labelTranslationKey="consents:email"
        isDisabled={disableAllFormControls}
        onCheckedChange={unCheckOtherFields(bpGroup, 'emailBP')}
      />
    ),
    mobilePhoneBP: () => (
      <CheckboxFormField
        fieldName="mobilePhoneBP"
        labelTranslationKey="consents:mobilePhone"
        isDisabled={disableAllFormControls}
        onCheckedChange={unCheckOtherFields(bpGroup, 'mobilePhoneBP')}
      />
    ),
    landlineBP: () => (
      <CheckboxFormField
        fieldName="landlineBP"
        labelTranslationKey="consents:landline"
        isDisabled={disableAllFormControls}
        onCheckedChange={unCheckOtherFields(bpGroup, 'landlineBP')}
      />
    ),
    postBP: () => (
      <CheckboxFormField
        fieldName="postBP"
        labelTranslationKey="consents:post"
        isDisabled={disableAllFormControls}
        onCheckedChange={unCheckOtherFields(bpGroup, 'postBP')}
      />
    ),
  };
}) satisfies (
  disableAllFormControls: boolean
) => Record<SummaryConsentFormModelFields, (...args: any[]) => ReactElement>;
